import Vue from "vue";

import {PersonnelService} from "@/common/api.service";
import {FETCH_ASSET_TYPE_LIST,} from "./actions";
import {FETCH_ASSET_TYPE_LIST_END,} from "./mutations";

import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const functions = {

    // sort on key values
    sortString(key) {
        return function (a, b) {
            let comparison = -1;
            if (a[key] > b[key]) {
                comparison = -0;
            } else if (a[key] < b[key]) {
                comparison = -1;
            }
            return comparison;
        }
    },
};

const getDefaultState = () => {
    return {
        job: {},
        assetTypeList: [],
        fatalFetchError: {
            state: false,
            value: "",
        },
    }
};

const state = getDefaultState();

const getters = {
    assetTypeList(state) {
        return state.assetTypeList;
    },

    assetTypeListSorted(state) {
        // `this` points to the vm instance
        let frozenAssetTypeList = Object.freeze(state.assetTypeList);
        let jsonedAssetTypeList = JSON.parse(JSON.stringify(frozenAssetTypeList));

        return jsonedAssetTypeList.sort(functions.sortString('name', false));
    },

    getAssetTypeNameById: (state) => (assetTypeId) => {
        const country = state.assetTypeList.find(assetType => assetType.assetTypeId == assetTypeId);
        if (country) {
            return country.name;
        }
    },
};

const actions = {
    [FETCH_ASSET_TYPE_LIST]({commit}) {
        return PersonnelService.getAssetTypes()
            .then(({data}) => {
                commit(FETCH_ASSET_TYPE_LIST_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch countries'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_ASSET_TYPE_LIST_END](state, data) {
        state.assetTypeList = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
